import { DEFAULT_JOIN_HIDE_DAYS } from "./joinInviteConfig";

export const JOIN_INVITE_STORAGE_KEY = "ms1.joinInvite.hiddenUntil";

const readUntil = () => {
  if (typeof window === "undefined") return 0;
  try {
    const raw =
      window.localStorage.getItem(JOIN_INVITE_STORAGE_KEY) ||
      window.sessionStorage.getItem(JOIN_INVITE_STORAGE_KEY);
    const n = Number(raw);
    return Number.isFinite(n) ? n : 0;
  } catch {
    return 0;
  }
};

export const isJoinInviteHidden = () => Date.now() < readUntil();

/** Hide the invite after close or a successful join. hideDays 0 = this tab only. */
export const rememberJoinInviteDismissed = (
  hideDays = DEFAULT_JOIN_HIDE_DAYS,
) => {
  if (typeof window === "undefined") return;
  const days = Number(hideDays);
  const useSession = !Number.isFinite(days) || days <= 0;
  const until = useSession
    ? Date.now() + 365 * 86400000
    : Date.now() + days * 86400000;
  try {
    if (useSession) {
      window.sessionStorage.setItem(JOIN_INVITE_STORAGE_KEY, String(until));
      window.localStorage.removeItem(JOIN_INVITE_STORAGE_KEY);
    } else {
      window.localStorage.setItem(JOIN_INVITE_STORAGE_KEY, String(until));
      window.sessionStorage.removeItem(JOIN_INVITE_STORAGE_KEY);
    }
  } catch {
    /* private mode */
  }
};
